<section>
    <div class="card" [ngClass]="{ 'no-coverage-int': (showCoverageNotAvailable && isInternationalSearch)}">
        <p class="header">{{ resultData.header }}</p>
        <p class="description" *ngIf="resultData.description">{{ resultData.description }}</p>
        <cms-text class="btn secondary-btn" *ngIf="resultData.ctaToAddPass" [originalText]="resultData.ctaToAddPass"
            (onButtonClick)="addAddon()"></cms-text>
        <p class="text-talk-info" [ngClass]="{
              'info-int': isInternationalSearch && !resultData.talkAndText,
              'info-int-searched': isInternationalSearch && resultData.talkAndText
            }">{{ resultData.footer }}
        </p>
        <div class="rates-container" *ngIf="resultData.talkAndText">
            <div class="type" *ngFor="let detail of resultData.talkAndText">
                <p class="label-text">{{ detail.header }}</p>
                <p class="amount">{{ detail.rate }}</p>
                <p class="subtext">{{ detail.unit }}</p>
            </div>
        </div>
    </div>
</section>
